import React from 'react';
import { HashLink } from 'react-router-hash-link';

export default function SustainabilitySection() {
  return (
    <section id="sustainability" className="sec">
      <div className="sus-inner">
        <div className="sus-split rv">
          <div>
            <div className="kicker k-green">Our Commitment</div>
            <h2 className="title lt fr">
              Harmony through
              <br />
              <em>Sustainability</em>
            </h2>
            <p className="sus-p">
              Sustainability at Auralux is engineered into molecular structure — not printed on packaging. We measure our
              environmental commitments in hard data and publish annual independent audits.
            </p>
            <HashLink smooth to="#contact" className="sus-cta">
              Download 2025 Sustainability Report →
            </HashLink>
            <div className="sus-certs">
              <span className="cert">ISO 9001</span>
              <span className="cert">ISO 14001</span>
              <span className="cert">FDA 21 CFR</span>
              <span className="cert">REACH</span>
              <span className="cert">RoHS</span>
              <span className="cert">HALAL</span>
              <span className="cert">EN 71-3</span>
              <span className="cert">BPA-Free</span>
            </div>
          </div>
          <div className="sus-mets">
            <div className="sus-m">
              <div className="sus-num">40%</div>
              <div className="sus-txt">
                <h4>Bio-Based Carriers</h4>
                <p>
                  Bio-feedstock carrier options available today without compromising pigment loading or processing
                  performance across any product family.
                </p>
              </div>
            </div>
            <div className="sus-m">
              <div className="sus-num">100%</div>
              <div className="sus-txt">
                <h4>rPET Compatibility</h4>
                <p>
                  All product lines tested and validated for full compatibility with mechanically recycled PET, HDPE, and
                  PP streams before any commercial launch.
                </p>
              </div>
            </div>
            <div className="sus-m">
              <div className="sus-num">Zero</div>
              <div className="sus-txt">
                <h4>Heavy Metals</h4>
                <p>
                  Complete pigment portfolio free from lead, cadmium, chromium VI, and all other regulated heavy metals
                  across every global market we serve.
                </p>
              </div>
            </div>
            <div className="sus-m">
              <div className="sus-num">2030</div>
              <div className="sus-txt">
                <h4>Net-Zero Target</h4>
                <p>
                  Committed to net-zero manufacturing by 2030, with 60% renewable energy already achieved across all
                  production sites globally.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
